import React from 'react';
import { AtomIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="tech-grid bg-blue-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-77" data-mp="1jcd4g9xq3yc0">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-78" data-mp="1eejyni0c16c9">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-79" data-mp="1ec7m5kdcfo6l">
          <AtomIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="1o43lszv2vmcx" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-81" data-mp="223mhuuam778v">
          Hecho por especialistas, para docentes de Latinoamérica.
        </h2>

        <Countdown light className="mt-8" data-id="element-82" data-mp="n5uj5u3cp9d2" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-slate-300/60 bg-blue-900 p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-83" data-mp="n6w54tlwng9k">
          <p data-id="element-84" data-mp="x2z8g2shtky3">
            <b className="block text-base leading-tight tracking-tight text-white" data-id="element-85" data-mp="x27e0vamtt9e">{productShortName}</b>
            <span className="text-sm text-slate-300" data-id="element-86" data-mp="1246fu0qq4i48">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-87" data-mp="1b2ruhkt2rczq">
            <p className="text-sm text-slate-300" data-id="element-88" data-mp="1b1gulw2r2pdw">
              <span className="mr-2 line-through" data-id="element-89" data-mp="1fvb7ognuo640">{priceBefore}</span>
              <b className="text-lg text-white" data-id="element-90" data-mp="1kt3cucdi9oq5">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-91" data-mp="1kvfu0nbfvv25">
              Quiero mi Megapack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-200" data-id="element-92" data-mp="1tryjtqodj2ui">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="3lwndc7dv6qcc">
              <CheckIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-94" data-mp="3hcu9jzkvh3j" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}